import React, {useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import {Link,useNavigate} from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
import Rightbar from './Rightbar';
import ImageUploading from 'react-images-uploading';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useSelector} from 'react-redux';
import { createPayment, getBoothTypePrice } from '../../Service';
import { useParams } from "react-router";
import {Table } from "react-bootstrap";
import Swal from "sweetalert2";

export default function Payment() {
    const [sidebar, setsidebar] = useState(false);
    const [mainbar, setmainbar] = useState(false);
    const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
    }
    const [date, setDate] = useState(new Date());
    const [images, setImages] = React.useState([]);
    const maxNumber = 69;
    
    const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
    };

    // ref my code
    const navigation = useNavigate();
    let loggedUser = useSelector(store => store.user['user']);
    let user_id = '';
    if(loggedUser){
      user_id = loggedUser.id;
    }
    
    const { id } = useParams();
      const event_id  = id;
    const [success, setSuccess] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("");
    const [orderID, setOrderID] = useState(false);
    const [list, setList] = useState([]);

    const [totalAmountVal, settotalAmountVal] = useState("");

    useEffect(() => {
      let paramsData={user_id:user_id, event_id:event_id};
      getBoothTypePrice(paramsData).then(res => setHandleResponse(res))
    },[]);

    const setHandleResponse = (res) => 
      {
        //console.log('res.data 107', res.data.data);
        setList(res.data.data);
        settotalAmountVal(res.data.data.total_amount)
      }

    // creates a paypal order
 const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Photola Payment",
            amount: {
              currency_code: "USD",
              value: localStorage.getItem('paypal_total_amount'),
              //value: 2,
            },
          },
        ],
        // not needed if a shipping address is actually needed
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then((orderID) => {
        setOrderID(orderID);
        return orderID;
      });
  };
  
  // check Approval
  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      const { payer } = details;
      setSuccess(true);
    });
  };
  //capture likely error
  const onError = (data, actions) => {
    setErrorMessage("An Error occured with your payment ");
  };
 
  useEffect(() => {
   if (success) {
     console.log("success",success);
     var bodyFormData = new FormData();
     bodyFormData.append('user_id', user_id);
     bodyFormData.append('event_id', event_id);
     bodyFormData.append('amount', list.total_amount);
     //bodyFormData.append('amount', 1);
     bodyFormData.append('currency_code', 'USD');
     bodyFormData.append('description', 'description');
     bodyFormData.append('orderid', orderID);
     bodyFormData.append('status', success);
     bodyFormData.append('event_status', 'pending');
     createPayment(bodyFormData).then(res => handleResponse(res))
   }
 },
 [success]
 );

 

 const handleResponse = (res) => 
      {
        
        if(res.status==200)
        {
          Swal.fire({
            position: 'center',
            icon: 'success',
            text: 'Paid Successfully!. Pending approval from Site Administrator.',
            showConfirmButton: true,
          })
            navigation("/thanks/");
        }
        else
        {

            navigation('/payment/'+event_id);
        }
      }
 
 console.log(1, orderID);
 console.log(2, success);
 console.log(3, ErrorMessage);
    
    // ref my code end

    return(
        <>
        
        <section className="sec-container" >
        <div className='container'>
        <div className='portalevent'>
        <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                <div >
                <Rightbar event_id={event_id} />
                </div>
            </div>
        <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
        <div className='rightbar '>
        <Button variant="outline-info" onClick={toggle}>
        <FontAwesomeIcon icon={faAlignLeft} />
        </Button>
        <h1>Payment</h1>
        <p className='red'>
        A $200 application fee and 10% booth deposit is are required to complete your 
        application. Booth deposits are refundable if your application is not approved. 
        All payments are processed using PayPal.
        </p>
            <div style={{"width":"100%"}} >
            <div className='table-responsive'>
<h1>Payment Details</h1>
<Table>
<thead>
<tr>
<th>Item</th>
 <th>Price</th>
{/* <th>Due Now</th> */}

        </tr>

      </thead>

      <tbody>

        

        <tr>

        <td width={"70%"} >Application Fee</td>

        <td width={"30%"}>$ {list.added_amount} USD</td>

        {/* <td>$ {list.percenage} USD</td> */}

        </tr>
        <tr>

          <td width={"70%"}>10% of Total Booth Price {list.price} [Booth Size {list.name}] </td>

          <td width={"30%"}>$ {list.percenage} USD</td>

          {/* <td>[10% of Total Price] USD</td> */}

        </tr>

        <tr>

        <td colSpan={1} width={"70%"}> Due Now - Total </td>

        <td width={"30%"}><strong>$ {list.total_amount} USD</strong></td>

         

        </tr>        

      </tbody>

    </Table>

        </div>
        <br />
            </div> 

            <PayPalScriptProvider 
     options={{
       "client-id":"AVPwu_pTvLiNsWVuQ_5kOEhy1bws9JEfQEZ5d6qXjxN9z3q_FydKTYzsoVHraTCWzklKnpMnR_lDZTuo", //live
       //"client-id":"AaK17DIRKiGD-0ua1uX-hb_wNPYQaNOtKri7-87nA14PiLfXEcRtP4l3_d23syj4-NrGSCs21Kgy_Dji", //sandbox
       //components: "buttons",
       //currency: "USD"
       
     }}
   >
     <div className='paypal-button'>
         <PayPalButtons style={{ layout: "vertical" }} createOrder={createOrder} onApprove={onApprove} />
     </div>
   </PayPalScriptProvider>                       
        </div>
        </div>
        </div>
        </div>
        </div>
        
        </section>
        </>
        )
    }